import { Controller } from "stimulus"

// #1977: in het bevestigingsvenster van een verplaatsing. Wie datum, tijden
// of het bereik aanpast, krijgt meteen een nieuwe controle (Van, Naar,
// meldingen en de datums die meegaan) in dezelfde frame. Zonder JavaScript
// doet de knop Controleren hetzelfde.
export default class extends Controller {
  static values = { controle: String }

  controleer() {
    const frame = this.element.closest("turbo-frame")
    const url = new URL(this.controleValue, window.location.origin)
    new FormData(this.element).forEach((waarde, sleutel) => {
      if (["_method", "authenticity_token", "bevestigd", "ongedaan"].includes(sleutel)) return
      url.searchParams.append(sleutel, waarde)
    })
    if (frame) {
      frame.src = url.toString()
    } else {
      window.location.href = url.toString()
    }
  }
}
